module.exports = __webpack_public_path__ + "static/firmaThumb-5857065eab7fe4c0a1243b7f386b6a44.webp";